import type { Locale } from '@change-corgi/config/locales';

import type { useAutocompleteService } from 'src/app/shared/hooks/googlePlaces';

type AutocompleteService = Exclude<ReturnType<typeof useAutocompleteService>, undefined>;
type GooglePlace = { name: string; id: string };
export async function getGooglePlaces(
	{ text, language, country }: { text: string; language: Locale; country: string },
	autocompleteService: AutocompleteService | undefined,
): Promise<GooglePlace[]> {
	if (text === '') return [];
	const results = await autocompleteService?.getPlacePredictions({
		types: ['(cities)'],
		componentRestrictions: { country },
		input: text,
		language,
	});

	return results?.predictions.map((prediction) => ({ name: prediction.description, id: prediction.place_id })) ?? [];
}
